import React, { FC, useEffect } from 'react'
import useGlobalModel from '../../model/globalModel'
import { useHistory } from 'react-router-dom'
import './Login.scss'
import { defaultMdCmParam, CLIENT_APP_CODE } from '@/utils/constants'
import { loginServiceAuth2, Auth2MenuDetail } from './LoginServiceAuth2'
import { SmileTwoTone } from '@ant-design/icons'
import { globalPrompt } from '@/components/message'
import './config'
import { ciApi } from '@/utils/ciHttpRequest'

interface ITokenLogin {
    token: string;
}

declare const window: Window & { loginTimer: NodeJS.Timeout | null }

export const TokenLogin: FC<ITokenLogin> = ({ token }) => {
    const history = useHistory()
    const {
        user,
        setUser,
        setResourceAuth,
        setCiDict,
        setCiStaticResources,
        setMenuAuth
    } = useGlobalModel()

    useEffect(() => {
        if (!window.loginTimer) {
            window.loginTimer = setTimeout(function() {
                beforeLogin().then(() =>{} )
            }, 1500)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const beforeLogin = async () => {
        //初始页数
        let { retData } = await loginServiceAuth2.VerifyInfo({ sourceApp: defaultMdCmParam.sourceApp, token })
        let { menus, resources, roles, shops, ...userInfo } = retData ?? {}
        //ci数据字典
        let { retData: ciDict } = await ciApi.ciDict()
        setCiDict(ciDict)
        //ci静态资源
        let { retData: StaticResources } = await ciApi.ciStaticResources()
        setCiStaticResources(StaticResources)
        //用户下没有门店或者门店信息不存在直接返回警告。
        // if (!shops || !shops.length) {
        // 	// loginServiceAuth2.Logout();
        // 	message.warning("该用户下没有门店信息,请联系后台人员配置门店信息", 5);
        // 	return;
        // }
        setResourceAuth(resources ?? [])  //设置资源列表

        //设置用户菜单所有权限列表,(递归查询到所有要展示得菜单地址。)
        let menuArr: string[] = []

        function findMenuAll(array: Auth2MenuDetail[]) {
            array.forEach(item => {
                item.linkUrl && menuArr.push(item.linkUrl)
                if (item.children && item.children.length > 0)
                    findMenuAll(item.children)
            })
        }

        findMenuAll(menus?.[CLIENT_APP_CODE] ?? [])
        setMenuAuth(menuArr)

        setUser({ ...user, ...userInfo, token, loginType: 'token' })
        globalPrompt('notification', {
            type: 'success',
            title: '登录成功',
            duration: 3,
            text: (
                <p className="bold">
					<span className="block">
						<SmileTwoTone /> {`您好!${userInfo.userName ?? ''}`}
					</span>
                    欢迎使用大包系统
                </p>
            )
        })
        history.push('/')
    }

    return (
        <div className="login">
            <div className="caseBlanche">
                <div className="rond">
                    <div className="test"></div>
                </div>
                <div className="load">
                    <p>loading</p>
                </div>
            </div>
        </div>
    )

}

export default TokenLogin
